//Content.js
import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import {globalConfig} from '../../config/config';
import HomePage from '../LearningCenter/HomePage';

function HomepageTelony()
{
        return (
        <>
        	<HomePage />
        {/*
        	<iframe width="100%" frameborder="false" height="900" src={globalConfig.breezeUrl} />
        */}
        </>
		)
}
export default HomepageTelony;